<template>
  <div class="bg-white rounded-2xl shadow-md p-6 mx-auto max-w-4xl mt-6">
    <h2 class="text-xl font-bold text-center mb-6">Mise à jour de la déclaration {{ currentClaim?.friendlyId }}</h2>

    <ClaimNewDeclarationVersionForm
      v-if="declarationUpdateRequest"
      :declaration="declaration"
      :declaration-update-request="declarationUpdateRequest"
    />
    <div v-else-if="isLoading" class="text-center text-gray-600">Chargement…</div>
    <div v-else-if="currentClaim" class="text-center text-gray-600">
      Ce sinistre ne nécessite pas de nouvelle version de la déclaration.
    </div>
    <div v-else class="text-center text-gray-600">Sinistre introuvable.</div>
  </div>
</template>

<script>
import { ClaimNewDeclarationVersionForm } from "@estaly/ui";
import { mapActions, mapState } from "vuex";

export default {
  components: { ClaimNewDeclarationVersionForm },

  computed: {
    ...mapState("claims", ["currentClaim"]),
    ...mapState("backoffice", ["isLoading"]),

    claimFriendlyId() {
      return this.$route.params.id;
    },

    declaration() {
      const declarations = this.currentClaim?.declarations || [];
      return declarations.find((d) => d.declarationUpdateRequest) || null;
    },

    declarationUpdateRequest() {
      return this.declaration?.declarationUpdateRequest || null;
    },
  },

  created() {
    this.withLoader(() => this.fetch(this.claimFriendlyId));
  },

  methods: {
    ...mapActions("claims", ["fetch"]),
    ...mapActions("backoffice", ["withLoader"]),
  },
};
</script>
